var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5621 8.7168H5.43655C5.0741 8.7168 4.78027 9.01062 4.78027 9.37307V18.5609C4.78027 18.9234 5.0741 19.2172 5.43655 19.2172H18.5621C18.9245 19.2172 19.2184 18.9234 19.2184 18.5609V9.37307C19.2184 9.01062 18.9245 8.7168 18.5621 8.7168Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04639 8.71704V5.76379C9.04639 4.98054 9.35753 4.22937 9.91137 3.67553C10.4652 3.12169 11.2164 2.81055 11.9996 2.81055C12.7829 2.81055 13.5341 3.12169 14.0879 3.67553C14.6417 4.22937 14.9529 4.98054 14.9529 5.76379V8.71704",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 14.9532C12.5432 14.9532 12.984 14.5125 12.984 13.9688C12.984 13.4251 12.5432 12.9844 11.9996 12.9844C11.4559 12.9844 11.0151 13.4251 11.0151 13.9688C11.0151 14.5125 11.4559 14.9532 11.9996 14.9532Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.87996f533ee3db91fffc56f8c52c2e23.svg";
export { ForwardRef as ReactComponent };